import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Route, useHistory } from "react-router-dom";
import { setIsDialogOpen } from "../../actions/dialog";
import { useDialogRouteStages } from "./useDialogRouteStages";
import { IDialogHandleState } from "../../reducers/dialog";
import { DialogRoute, IDialogRouteChildren } from "./DialogRoute";

interface IMultiDialogRotueProps {
    RouteSteps: IRouteSteps[];
    navigateBackRotue: string;
}

export interface IMultiDialogChildren extends IDialogRouteChildren {
    closeAll: () => void;
    routePath: string;
    stages: IDialogHandleState<any>[];
    history: any;
    dialogKey: string;
}

/**
 * Multi dialog step routes
 * Array of steps going in order with rotues
 * @param param0 
 * @returns 
 */
export function MultiDialogRoute({ RouteSteps, navigateBackRotue }: IMultiDialogRotueProps) {
    const history = useHistory();
    const { t } = useTranslation();
    const modalProps = useDialogRouteStages(history);
    const dispatch = useDispatch();

    function navigateBackFunction() {
        /**If it falls out dialog state */
        if (history.location.pathname === navigateBackRotue) {
            closeAll();
            return;
        }
        /**Force back open after animation completed */
        setTimeout(() => {
            dispatch(setIsDialogOpen(true));
        }, 400);
    }

    function closeAll() {
        /**When completed clear the stages */
        modalProps.closeAllModals(navigateBackRotue);
    }

    return <>
        {
            RouteSteps.map((step, index) => {
                const stages = modalProps?.stages;
                const stage = stages[step.key];
                return <Route path={step.path} exact={step.exact ?? false}>
                    <DialogRoute
                        Component={step.Component}
                        navigateBackRoute={!stage?.prevKey ? navigateBackRotue : (stages[stage?.prevKey]?.path ?? navigateBackRotue)}
                        ComponentPropsFunctions={{
                            ...step.componentProps,
                            history,
                            routePath: navigateBackRotue,
                            closeAll,
                            ...stage?.ComponentProps,
                            dialogKey: step.key
                        }}
                        dialogTitle={stage?.dialogTitle ? stage?.dialogTitle : t(step?.title ?? "")}
                        dialogClassName={step.dialogClassName}
                        navigateBackFunction={index === 0 || !stage || !stage?.prevKey ? closeAll : navigateBackFunction}
                        isFormDialog={step.isFormDialog}
                        // onCloseIcon={closeAll}
                    />
                </Route>
            })
        }
    </>
}